import { apiSlice } from '../../../api/apiSlice';
import * as constants from '../../../constants';

export const CoachingHistoryGridSlice = apiSlice.injectEndpoints({
    endpoints: (builder: any) => ({
        getDirectReportees: builder.query({
            query: (arg: any) => {
                return {
                    url: constants.COACHING_DIRECT_REPORTEES,
                    params: arg,
                };
            },
            providesTags: ['DirectReportees'],
        }),
        getCurrentMonthAcitivity: builder.query({
            query: (arg: any) => {
                return {
                    url: constants.COACHING_CURRENT_MONTH_ACTIVITY,
                    params: arg,
                };
            },
            providesTags: ['CurrentMonthAcitivity', 'Activity','Coaching','CoachingGoalInfo'],
        }),
        getActivitySummary: builder.query({
            query: (arg: any) => {
                const { empNumber, loggedEmpNumber, year } = arg;
                return {
                    url: constants.COACHING_ACTIVITY_SUMMARY,
                    params: {
                        empNumber,
                        loggedEmpNumber,
                        year,
                    },
                };
            },
            providesTags: ['Activity', 'Coaching','CoachingGoalInfo'],
        }),
        getActivityEmployeeSearch: builder.query({
            query: (arg: any) => {
                const { loggedEmpRole, loggedEmpNumber, searchedEmpNumber } = arg;
                return {
                    url: constants.COACHING_ACTIVITY_EMPLOYEE_SEARCH,
                    params: {
                        loggedEmpRole,
                        loggedEmpNumber,
                        searchedEmpNumber,
                    },
                };
            },
        }),
        getSignedUrl: builder.mutation({
            query: (fileNames: string[]) => ({
                url: constants.SIGNED_URL,
                method: 'POST',
                body: fileNames,
            }),
        }),
    }),
});

export const {
    useGetDirectReporteesQuery,
    useGetCurrentMonthAcitivityQuery,
    useGetActivitySummaryQuery,
    useGetActivityEmployeeSearchQuery,
    useGetSignedUrlMutation,
} = CoachingHistoryGridSlice;
